import { navigateAjax, navigateWithTopBar } from '../shared/guarded-navigation.js';
import { showTopLoadingBar, hideTopLoadingBar } from '../shared/top-loading-bar.js';
import { handleMemberSpaRequestError } from './member-spa-auth.js';
import { showAlertMsg } from './member-show-alert-msg.js';
import { memberCongregationId, withMemberCongregationQuery } from './member-nav-config.js';

export function toggleLoginFlowBars(show) {
    if (show) {
        $('body').addClass('login-flow-active');
    } else {
        $('body').removeClass('login-flow-active');
    }
}

export function syncFullPageBodyClasses() {
    $('body').toggleClass('member-pledges-full-page', $('#index_paging .member-pledges-page').length > 0);
    $('body').toggleClass('account-settings-full-page', $('#index_paging #accountSettingsShell').length > 0);
    $('body').toggleClass('member-home-page-active', $('#index_paging .member-home-layout').length > 0);
}

export function touchMemberActivity() {
    window.user_active = true;
    window.last_activity = Date.now();
}

function resolveNavUrl(url, httpMethod) {
    return httpMethod === 'GET' ? withMemberCongregationQuery(url) : url;
}

function wrapSuccessCheck(onSuccess) {
    return function (data) {
        if (data.success) {
            onSuccess(data);
        } else {
            showAlertMsg(data.error, 'danger');
        }
    };
}

export function runAjaxCommand(route, method, onPageInjected) {
    const httpMethod = method || 'GET';
    showTopLoadingBar();
    const opts = {
        url: resolveNavUrl(route, httpMethod),
        type: httpMethod,
        success: wrapSuccessCheck(function (data) {
            $('#index_paging').html(data.page_info);
            syncFullPageBodyClasses();
            if (typeof onPageInjected === 'function') {
                onPageInjected();
            }
            toggleLoginFlowBars($('#index_paging .login-flow-page').length > 0);
        }),
        error: handleMemberSpaRequestError,
        complete: function () {
            hideTopLoadingBar();
        }
    };

    if (httpMethod === 'POST') {
        opts.data = { congregation_id: memberCongregationId() };
    }

    return navigateAjax(opts);
}

export function runOverlayNavCommand(ajaxOptions) {
    const httpMethod = ajaxOptions.type || 'GET';
    return navigateWithTopBar(Object.assign({}, ajaxOptions, {
        forceTopBar: true,
        url: resolveNavUrl(ajaxOptions.url, httpMethod),
        success: wrapSuccessCheck(ajaxOptions.success),
        error: handleMemberSpaRequestError,
    }));
}
